<template>
  <div class="index py-5">
    <div class="list-container">
      <AveineOrderList :APIbaseURL="APIbaseURL" :adminMode="true"/>
    </div>
  </div>
</template>

<script>

import { AveineOrderList } from 'aveine-sale';
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineOrderList
  }
}
</script>
